import {IUserProfile} from '../../interfaces/HotelReservationV2/IUserProfile-IV2';
import {IPersonName } from '../../interfaces/HotelReservationV2/IPersonName';
import {ILoyaltyProgram } from '../../interfaces/HotelReservationV2/ILoyaltyProgram';
import {ITelephone} from '../../interfaces/HotelReservationV2/ITelephone';
import {IEmail} from '../../interfaces/HotelReservationV2/IEmail';
import {IGuest} from '../../interfaces/HotelReservation/IGuest';
import {Guest} from '../../model/guest/guest.model';


export class UserProfileBuilder {
    private _userProfile: IUserProfile;
    constructor() {
        this._userProfile = <IUserProfile>{};
        this._userProfile.telephones = []; //<ITelephone>
    }
    withID (id: number) {
        this._userProfile.id = id;
        return this;
    }
    withGuest (guest: IGuest) {
        this._userProfile.personName = <IPersonName>{surname: guest.lastName, given: guest.firstName};
        this._userProfile.id = guest.id;
        //this._userProfile.telephones.push(<ITelephone>{number: guest.phoneNumber}); // todo: this is commented until contract-service misalignment can be resolved. uncomment it during the next phase of integration
        if (guest.rewardsClubNumber){
            this._userProfile.loyaltyProgram = <ILoyaltyProgram>{loyaltyId: guest.rewardsClubNumber};
        }
        return this;
    }
    build (): IUserProfile {
        return this._userProfile;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/user-profile.builder.ts